import React from 'react';
import styled from 'styled-components';
import { CartonStatus } from '../types';

interface StatusBadgeProps {
  status: CartonStatus;
  children: React.ReactNode;
}

const getStatusColor = (status: CartonStatus) => {
  switch (status) {
    case 'received':
      return 'success';
    case 'dispatched':
      return 'primary';
    case 'site_dispatched':
      return 'info';
    case 'factory_dispatched':
      return 'warning';
    case 'assembled':
      return 'success';
    case 'missing':
      return 'error';
    case 'damaged':
      return 'error';
    case 'partial':
      return 'warning';
    default:
      return 'secondary';
  }
};

export const StatusBadge = styled.span<StatusBadgeProps>`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[1]} ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  font-size: ${({ theme }) => theme.typography.sm};
  font-weight: ${({ theme }) => theme.typography.medium};
  text-transform: capitalize;
  background-color: ${({ theme, status }) => theme.colors[`${getStatusColor(status)}Background`]};
  color: ${({ theme, status }) => theme.colors[getStatusColor(status)]};
`; 